import { useEffect } from 'react';
import { usePlatform } from '~/services/platform';
import { useStore } from '~/stores';
import { logRocketService } from '~/services/logrocket';

export function useLogRocket(): void {
  const platform = usePlatform();
  const { authStore } = useStore();

  useEffect(() => {
    logRocketService.init(platform.platform);
  }, [platform.platform]);

  useEffect(() => {
    if (authStore.isAuthenticated && authStore.deviceId) {
      logRocketService.identify({
        deviceId: authStore.deviceId,
        playerId: authStore.playerId,
        platform: platform.platform,
        tenantId: authStore.tenantId,
        tenantSlug: authStore.tenantSlug,
        tenantName: authStore.tenantName,
      });
    }
  }, [
    authStore.isAuthenticated,
    authStore.deviceId,
    authStore.playerId,
    authStore.tenantId,
    authStore.tenantSlug,
    authStore.tenantName,
    platform.platform,
  ]);
}
